import React, { useState, useEffect } from 'react';
import useIsTestVersion from '../hooks/useIsTestVersion';

const FloatingHelpButton = () => {
  const isTest = useIsTestVersion();
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 10) {
        // Scrolling down
        setIsVisible(false);
      } else {
        // Scrolling up
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  // New look has its own help buttons, so hide this floating Richpanel one there.
  if (isTest) return null;

  return (
    <>
      {/* Floating Help Button - Only visible on mobile */}
      <button
        onClick={() => setIsOpen(true)}
        className={`md:hidden ${isTest ? 'absolute' : 'fixed'} top-1.5 right-1.5 xxs:top-2 xxs:right-2 w-7 h-7 xxs:w-8 xxs:h-8 xs:w-9 xs:h-9 rounded-full flex items-center justify-center z-40 transition-all duration-300 ${
          isTest ? 'bg-[#544947] hover:bg-[#544947]/90' : 'bg-primary hover:bg-primary-dark'
        } ${
          (isTest || isVisible) ? 'translate-y-0 opacity-100' : '-translate-y-20 opacity-0'
        }`}
        style={{
          fontFamily: 'Idler Pro Solid',
          color: '#fffdf9',
          outline: '#fdf4ed solid 2px',
          outlineOffset: '-5px'
        }}
        aria-label="Help"
      >
        <span className="text-sm xxs:text-base xs:text-lg">?</span>
      </button>

      {/* Modal Overlay */}
      {isOpen && (
        <div className="md:hidden fixed inset-0 z-50 bg-black bg-opacity-50">
          {/* Modal Content */}
          <div className="absolute inset-2 xxs:inset-3 xs:inset-4 bg-white rounded-lg shadow-xl flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-center p-3 xxs:p-3.5 xs:p-4 border-b relative">
              <h2 className="text-base xxs:text-base xs:text-lg font-semibold">Help Center</h2>
              <button
                onClick={() => setIsOpen(false)}
                className="absolute right-3 xxs:right-3.5 xs:right-4 text-gray-500 hover:text-gray-700 text-xl xxs:text-2xl leading-none p-1"
                aria-label="Close"
              >
                ×
              </button>
            </div>

            {/* Iframe */}
            <div className="flex-1 overflow-hidden">
              <iframe
                src="https://wildgrain.customerdesk.io"
                className="w-full h-full border-0"
                title="Help Center"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingHelpButton;
